import styled from 'styled-components'

import { NEUTRAL_COLOURS } from 'constants/colors'

import { getBrandingColor } from 'utils/branding'

export const StyledContent = styled.div`
  border: 1px solid ${NEUTRAL_COLOURS.GRAY_TERTIARY};
  background: ${NEUTRAL_COLOURS.GRAY_QUATERNARY};
  border-radius: 8px;
  padding: 8px 24px;
  min-height: 100%;
`

interface StyledSidebarItemProps {
  $active: boolean
}

export const StyledSidebarItem = styled.div<StyledSidebarItemProps>`
  padding: 14px 24px 11px;
  border-top: 1px solid ${NEUTRAL_COLOURS.GRAY_SECONDARY};
  cursor: pointer;
  margin-bottom: 8px;
  transition: color .2s ease-in-out, background .2s ease-in-out;

  &:hover {
    color: ${getBrandingColor('senary-color')};
    background: ${getBrandingColor('primary-color-rgba-2')};
  }
    
  ${({ $active }) => $active && `
    color: ${getBrandingColor('senary-color')};
    background: ${getBrandingColor('primary-color-rgba-2')};
  `}
`

interface StyledGroupItemProps {
  $active: boolean
}

export const StyledGroupItem = styled.div<StyledGroupItemProps>`
  padding: 12px 24px;
  margin: 1px 0;
  border-radius: 8px;
  cursor: pointer;
  transition: color .2s ease-in-out, background .2s ease-in-out;

  &:hover {
    color: ${getBrandingColor('senary-color')};
    background: ${getBrandingColor('primary-color-rgba-2')};
  }
    
  ${({ $active }) => $active && `
    color: ${getBrandingColor('senary-color')};
    background: ${getBrandingColor('primary-color-rgba-2')};
  `}
`
